import { jsx as _jsx } from "react/jsx-runtime";
import { InputMultiSelect, } from "../../../../InputMultiSelect";
export const MultiOptionFilter = (props) => {
    const { label, helperLabel, options, value, onChange, } = props;
    return (_jsx(InputMultiSelect, { label: label, ariaLabel: label, helperLabel: helperLabel, options: options, value: value, onChange: onChange }));
};
